import React from "react";
import {
  readablePrice,
  isDiscountedItem,
  totalQuantityOfVariant,
  getLineNum
} from "./cartHelpers";
import VariantSelector from "./variantSelector";
import sharedStyles from "../util/sharedStyles";

class LineItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      item: props.item,
      variants: [],
      selectedVariant: props.selectedVariant,
      rateLimited: false,
      discounted: isDiscountedItem(props.item)
    };
  }

  componentDidMount() {
    $.ajax({
      url: "/products/" + this.props.item.handle + ".js",
      type: "GET",
      dataType: "json"
    }).done(data => {
      const variants = data.variants.filter(variant => {
        // for some reason inventory_quantity isn't included on the DE, EU store's response,
        // so we use variant.available instead in that case.
        if (variant.inventory_quantity) {
          return variant.inventory_quantity >= this.state.item.quantity;
        } else {
          return variant.available;
        }
      });
      this.setState({ variants: variants });
    });
  }

  rateLimit = () => {
    this.setState({ rateLimited: true });
    setTimeout(() => {
      if (this) {
        this.setState({ rateLimited: false });
      }
    }, 800);
  };

  handleDecrement = e => {
    e.preventDefault();
    if (this.props.loading || this.state.rateLimited) {
      return false;
    }

    this.rateLimit();

    this.props.setLoading(true);
    if (this.state.item.quantity <= 0) {
      return false;
    }

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        line: this.props.lineNum,
        quantity: this.state.item.quantity - 1
      }
    })
      .done(this.props.updateCartUI)
      .fail(this.props.updateCartUI);
  };

  handleIncrement = e => {
    e.preventDefault();
    if (this.props.loading || this.state.rateLimited) {
      return false;
    }

    this.rateLimit();

    this.props.setLoading(true);

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        id: this.state.item.variant_id,
        quantity: 1
      }
    })
      .done(() => this.props.updateCartUI())
      .fail(this.props.updateCartUI);
  };

  deleteLine = e => {
    e.preventDefault();
    if (this.props.loading || this.state.rateLimited) {
      return false;
    }

    this.rateLimit();

    this.props.setLoading(true);

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      dataType: "json",
      data: {
        line: this.props.lineNum,
        quantity: 0
      }
    })
      .done(this.props.updateCartUI)
      .fail(this.props.updateCartUI);
  };

  changeVariant = newVariant => {
    if (this.props.loading || this.state.rateLimited) {
      return false;
    }

    this.rateLimit();
    this.props.setLoading(true);

    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: {
        line: this.props.lineNum,
        quantity: 0
      },
      dataType: "json"
    })
      .done(newCart => {
        // console.log("second");
        // console.log(newCart.items.map((item) => item.variant_id + ": " + item.quantity));
        // console.log(totalQuantityOfVariant(newVariant, newCart.items));
        // console.log("state q: ", this.state.item.quantity);

        let newVariants = newCart.items
          .map((item, i) => {
            item["lineNum"] = i + 1;
            return item;
          })
          .filter(item => item.variant_id == newVariant);

        if (newVariants.length > 0) {
          let lineToChange = null;
          let newVariantQ = totalQuantityOfVariant(newVariant, newCart.items);

          // figure out the line to change, and the quantity that is already in that line (newVariantQ)
          for (let ind = 0; ind < newVariants.length; ind++) {
            if (ind < newVariants.length - 1) {
              newVariantQ -= newVariants[ind].quantity;
            }
            lineToChange = newVariants[ind].lineNum;
          }
          // console.log("line to change", lineToChange);
          // console.log("newVarQ: ", newVariantQ);

          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            dataType: "json",
            data: {
              line: lineToChange,
              quantity: newVariantQ + this.state.item.quantity // the quantity already in that line, plus new ones we're adding.
            }
          })
            .done(newCart => {
              // console.log("third");
              // console.log(newCart.items.map((item) => item.variant_id + ": " + item.quantity));

              this.props.updateCartUI(newCart);
            })
            .fail(this.props.updateCartUI);
        } else {
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            dataType: "json",
            data: {
              id: newVariant,
              quantity:
                totalQuantityOfVariant(newVariant, newCart.items) +
                this.state.item.quantity
            }
          })
            .done(() => this.props.updateCartUI())
            .fail(this.props.updateCartUI);
        }
      })
      .fail(this.props.updateCartUI);
  };

  itemPrice = item => {
    if (isDiscountedItem(item)) {
      return (
        <td className="price">
          <strike>{readablePrice(item.original_price)}</strike>&nbsp;
          {readablePrice(item.line_price / item.quantity)}
        </td>
      );
    } else {
      return <td className="price">{readablePrice(item.price)}</td>;
    }
  };

  _previewImage = item => {
    if (item.properties && item.properties._generated_preview) {
      return <img src={item.properties._generated_preview} alt={item.title} />;
    } else {
      return <img src={item.image} alt={item.title} />;
    }
  };

  regularItem = item => {
    return (
      <tr className="table-row first ">
        <td className="product-item first">
          <div className="image-wrap">
            <a className="image" href={"/products/" + item.handle}>
              <img src={item.image} alt={item.title} />
            </a>
          </div>
          <div className="wrap">
            <span className="label vendor">Charmed Aroma</span>
            <span className="label title">
              <a href={"/products/" + item.handle} title={item.title}>
                {item.title}
              </a>
            </span>
            <span
              className="label variant"
              style={{ height: "33px", width: "100%" }}
            >
              <VariantSelector
                changeVariant={this.changeVariant}
                variants={this.state.variants}
                selectedVariant={this.state.selectedVariant}
                title={item.variant_title}
              />
            </span>
          </div>
        </td>
        {this.itemPrice(item)}
        <td className="quantity" style={{ minWidth: 156 + "px" }}>
          <input
            className="action-button decrement"
            onClick={this.handleDecrement}
            type="submit"
            style={sharedStyles.decrementButton}
            value="-"
          />
          <input
            className="quantity field"
            readOnly="readonly"
            style={{ margin: "0 4px" }}
            type="text"
            className="field"
            name="updates[]"
            id={"updates_" + item.id}
            value={item.quantity}
          />
          <input
            className="action-button increment"
            onClick={this.handleIncrement}
            type="submit"
            style={sharedStyles.incrementButton}
            value="+"
          />
        </td>
        <td className="total">{readablePrice(item.line_price)}</td>
        <td className="remove last">
          <a
            className="remove"
            onClick={this.deleteLine}
            href="javascript:void(0);"
          >
            v
          </a>
        </td>
      </tr>
    );
  };

  hiddenItem = item => {
    return (
      <tr className="table-row first ">
        <td className="product-item first">
          <div className="image-wrap">
            <a className="image" href="javascript:void(0);">
              <img src={item.image} alt={item.title} />
            </a>
          </div>
          <div className="wrap">
            <span className="label vendor">Charmed Aroma</span>
            <span className="label title">
              <a href="javascript:void(0);" title="">
                {item.title}
              </a>
            </span>
            <span
              className="label variant"
              style={{ height: "33px", width: "100%" }}
            >
              <VariantSelector
                changeVariant={this.changeVariant}
                variants={this.state.variants}
                selectedVariant={this.state.selectedVariant}
                title={item.variant_title}
              />
            </span>
          </div>
          {this.state.variants.length > 1 && (
            <div style={{ marginTop: "10px", color: "red" }}>
              Don't forget to choose your ring size!
            </div>
          )}
        </td>
        {this.itemPrice(item)}
        <td
          className="quantity"
          style={{ minWidth: "156px", paddingLeft: "31px" }}
        >
          <input
            readOnly="readonly"
            type="text"
            className="field"
            name="updates[]"
            id={"updates_" + item.variant_id}
            value={item.quantity}
          />
        </td>
        <td className="total">{readablePrice(item.line_price)}</td>
        <td className="remove last">
          <a
            className="remove"
            onClick={this.deleteLine}
            href="javascript:void(0);"
          >
            v
          </a>
        </td>
      </tr>
    );
  };

  customizedItem = item => {
    return (
      <tr className="table-row first ">
        <td className="product-item first">
          <div className="image-wrap">
            <a className="image" href="javascript:void(0);">
              {this._previewImage(item)}
            </a>
          </div>
          <div className="wrap">
            <span className="label vendor">Charmed Aroma</span>
            <span className="label title">
              <a href="javascript:void(0);" title="">
                {item.title}
              </a>
            </span>
          </div>
        </td>
        {this.itemPrice(item)}
        <td
          className="quantity"
          style={{ minWidth: "156px", paddingLeft: "31px" }}
        >
          <input
            readOnly="readonly"
            type="text"
            className="field"
            name="updates[]"
            id={"updates_" + item.variant_id}
            value={item.quantity}
          />
        </td>
        <td className="total">{readablePrice(item.line_price)}</td>
        <td className="remove last">
          <a
            className="remove"
            onClick={this.deleteLine}
            href="javascript:void(0);"
          >
            v
          </a>
        </td>
      </tr>
    );
  };

  render() {
    if (
      this.state.item.properties &&
      Object.keys(this.state.item.properties).length > 0
    ) {
      return this.customizedItem(this.state.item);
    } else if (this.state.item.product_type === "hidden") {
      return this.hiddenItem(this.state.item);
    } else {
      return this.regularItem(this.state.item);
    }
  }
}

export default LineItem;
